module.exports = __webpack_public_path__ + "img/header.c09bf80.jpg";